import React from 'react';
import { useTheme } from 'styled-components';

const AccordionArrow = () => {
    const theme = useTheme();
    return (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.72599 3.27991L0.305176 4.75953L7.99946 12.72L15.6937 4.75953L14.2729 3.27991L7.99946 9.77042L1.72599 3.27991Z", fill: theme.colors.iconColor })));
};

export { AccordionArrow as default };
//# sourceMappingURL=AccordionArrow.mjs.map
